import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

/**
 * Returns the user with the given id.
 *
 * Not group-scoped: this resolves a reference (a trip's driver, a comment's author), and the
 * referenced user's own company groups need not overlap the groups picked on the page. Scoping
 * would blank the name of a driver whose groups lie outside the selected depot.
 *
 * @param id - The id of the user.
 * @returns - The {@link User}.
 */
export function useUserById(id?: string) {
  const { geotabClient, activeSessionId } = useGeotabClient();
  return useQuery({
    queryKey: ["user", activeSessionId, id],

    queryFn: ({ signal }) => {
      if (!id) {
        return Promise.resolve(null);
      }
      return geotabClient.get("User", { id }, 1, signal).then(users => users[0] ?? null);
    },
  });
}
